/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Total_Bags_LabelInputs */

const en_cargo_total_bags_label = /** @type {(inputs: Cargo_Total_Bags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Bags *`)
};

const es_cargo_total_bags_label = /** @type {(inputs: Cargo_Total_Bags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas totales *`)
};

/**
* | output |
* | --- |
* | "Total Bags *" |
*
* @param {Cargo_Total_Bags_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_total_bags_label = /** @type {((inputs?: Cargo_Total_Bags_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Total_Bags_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_total_bags_label(inputs)
	return es_cargo_total_bags_label(inputs)
});